/**
 * 路由相关常量（非 SEO 文案）。
 * 站点 title/description/OG：统一用 `@/src/const/seo` 的 `getSEOConfig(locale)`。
 */
export const appTypes = ["h5", "android", "ios", "desktop"];
